import { flow, getEnv, types } from 'mobx-state-tree';
import { isEmpty, pickBy } from 'lodash';

import { getLaunchDarklyStatus } from './get-launch-darkly-status';

const FeatureFlagStore = types
  .model('FeatureFlagStore', {
    features: types.optional(types.frozen(), {}),
    launchDarklyStatus: false,
    loaded: false,
    loading: false,
    hasError: false,
  })
  .actions(self => {
    const { getApiClient, logger, platform } = getEnv(self);

    return {
      afterCreate: () => {
        const { featureFlags = {} } = getEnv(self);
        self.features = { ...self.features, ...featureFlags };
        self.getlaunchDarklyStatus();
      },
      set: features => {
        self.features = {
          ...self.features,
          ...features,
        };
      },
      getlaunchDarklyStatus: flow(function*() {
        try {
          if (self.loading) {
            return;
          }

          self.loading = true;
          self.loaded = false;
          self.hasError = false;

          const client = yield getApiClient();
          const { data } = yield getLaunchDarklyStatus({ client, platform });
          const { enabled, featureFlags } = data.launchDarklyStatus;

          // @note: set initial values for feature flags
          self.set(JSON.parse(featureFlags));
          self.launchDarklyStatus = enabled;
          self.loaded = true;
        } catch (error) {
          self.hasError = true;
          logger.warn('Unable to get if launch darkly is enabled. Setting to false.', { error });
        }

        self.loading = false;
      }),
    };
  })
  .views(self => ({
    get activeFeatures() {
      return pickBy(self.features);
    },

    isActive(flag) {
      return self.features[flag] || false;
    },

    get featureFlags() {
      return self.features;
    },

    get hasFeatureFlags() {
      return !isEmpty(self.features);
    },
  }));

export default FeatureFlagStore;
